import { ANALYTICS_ALL_PAGES, ANALYTICS_BLOG_POSTS, ANALYTICS_BROWSER_DETAILS, ANALYTICS_CAMPAIGNS, ANALYTICS_DEVICE_TYPES, ANALYTICS_DEVICE_TYPE_DETAILS, ANALYTICS_FORMS, ANALYTICS_FORMS_URLS, ANALYTICS_FORMS_SOURCES, ANALYTICS_GEOLOCATION, ANALYTICS_KNOWLEDGE_ARTICLES, ANALYTICS_KNOWLEDGE_ARTICLES_SOURCES, ANALYTICS_SALES_DOCUMENTS, ANALYTICS_SALES_TEMPLATES, ANALYTICS_SEQUENCE_ENROLLMENT_ACTIVITIES, ANALYTICS_SOURCES, ANALYTICS_STANDARD_PAGES, ANALYTICS_TOPICS, ANALYTICS_UTM_CAMPAIGNS, ANALYTICS_UTM_CONTENTS, ANALYTICS_UTM_MEDIUMS, ANALYTICS_UTM_SOURCES, ANALYTICS_UTM_TERMS, EMAIL, SEQUENCE_SENDER_SCORE, SOCIAL_CHANNELS, SOCIAL_POSTS, UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS, UNIFIED_FEEDBACK_TRENDS, ANALYTICS_LANDING_PAGES } from 'reporting-data/constants/dataTypes';
export const DATA_TYPE_FAMILIES = {
  ADS: 'ADS',
  BLOG: 'BLOG',
  CAMPAIGNS: 'CAMPAIGNS',
  CHATBOT: 'CHATBOT',
  CTAS: 'CTAS',
  DOCUMENTS: 'DOCUMENTS',
  FEEDBACK: 'FEEDBACK',
  FORMS: 'FORMS',
  GOALS: 'GOALS',
  HD_MESSAGES: 'HD_MESSAGES',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  LINE_ITEMS: 'LINE_ITEMS',
  LISTS: 'LISTS',
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  MARKETING_EVENTS: 'MARKETING_EVENTS',
  PAGES: 'PAGES',
  SEO: 'SEO',
  SEQUENCES: 'SEQUENCES',
  SMS: 'SMS',
  SOCIAL: 'SOCIAL',
  TEMPLATES: 'TEMPLATES',
  UTM_PARAMS: 'UTM_PARAMS'
};
const DATA_TYPE_KEYWORDS = {
  '0-1': ['contact', 'customer', 'decision_maker'],
  // CONTACT
  '0-2': ['company', 'companies'],
  // COMPANY
  '0-3': ['deal', 'customer', 'amount', 'revenue'],
  // DEAL
  '0-5': ['ticket'],
  // TICKET
  '0-11': ['conversation'],
  // CONVERSATION
  '0-27': ['task'],
  // TASK
  '0-39': ['blog'],
  // BLOG_POST
  '0-44': ['workflow'],
  // AUTOMATION_PLATFORM_FLOW
  '0-47': ['meeting'],
  // MEETING_EVENT
  '0-48': ['call'],
  // CALL
  '0-49': ['tracked_inbox_email'],
  // EMAIL (SALES)
  '0-53': ['invoice'],
  // INVOICE
  '0-60': ['forecast', 'projected'],
  '0-69': ['subscription'],
  // SUBSCRIPTION
  '0-101': ['payment'],
  // COMMERCE_PAYMENT
  '0-115': ['_user_'],
  // USER
  '0-123': ['ecommerce_order'],
  // ORDER
  [DATA_TYPE_FAMILIES.ADS]: ['_ad_'],
  [DATA_TYPE_FAMILIES.CAMPAIGNS]: ['campaign'],
  [DATA_TYPE_FAMILIES.CHATBOT]: ['chatbot'],
  [DATA_TYPE_FAMILIES.CTAS]: ['cta', 'web_interactive'],
  [DATA_TYPE_FAMILIES.DOCUMENTS]: ['document'],
  [DATA_TYPE_FAMILIES.FEEDBACK]: ['feedback'],
  [DATA_TYPE_FAMILIES.FORMS]: ['form', 'submissions'],
  [DATA_TYPE_FAMILIES.HD_MESSAGES]: ['hd_message', 'customer_agent'],
  [DATA_TYPE_FAMILIES.KNOWLEDGE_BASE]: ['knowledge'],
  [DATA_TYPE_FAMILIES.MARKETING_EMAIL]: ['bounce', '_mta_'],
  [DATA_TYPE_FAMILIES.MARKETING_EVENTS]: ['marketing_event'],
  [DATA_TYPE_FAMILIES.PAGES]: ['web_analytics', 'page', 'cookie_banner', 'origin', 'url'],
  [DATA_TYPE_FAMILIES.SEO]: ['gsc'],
  // (gsc = Google search console)
  [DATA_TYPE_FAMILIES.SEQUENCES]: ['sequence'],
  [DATA_TYPE_FAMILIES.SMS]: ['shortmessage'],
  [DATA_TYPE_FAMILIES.SOCIAL]: ['social']
};
const DATA_TYPE_FAMILY_MEMBERS = {
  [DATA_TYPE_FAMILIES.ADS]: ['0-30',
  // AD_ACCOUNT
  '0-33',
  // AD
  UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS],
  [DATA_TYPE_FAMILIES.BLOG]: ['0-39', ANALYTICS_BLOG_POSTS],
  // BLOG POST,
  [DATA_TYPE_FAMILIES.CAMPAIGNS]: [ANALYTICS_CAMPAIGNS, '0-35',
  // CAMPAIGN
  'P-CAMPAIGNS',
  // CRB virtual data source
  UNIFIED_ADS_CAMPAIGNS],
  [DATA_TYPE_FAMILIES.CTAS]: ['0-42',
  // CTA
  '0-91' // WEB_INTERACTIVE
  ],
  [DATA_TYPE_FAMILIES.DOCUMENTS]: [ANALYTICS_SALES_DOCUMENTS],
  [DATA_TYPE_FAMILIES.FEEDBACK]: ['0-19', UNIFIED_FEEDBACK_TRENDS],
  // FEEDBACK_SUBMISSION
  [DATA_TYPE_FAMILIES.FORMS]: [ANALYTICS_FORMS, ANALYTICS_FORMS_SOURCES, ANALYTICS_FORMS_URLS, '0-15',
  // FORM_SUBMISSION
  '0-28',
  // FORM
  'V_FORM_SUBMISSIONS', 'D-FORM_CONVERSIONS'],
  [DATA_TYPE_FAMILIES.KNOWLEDGE_BASE]: [ANALYTICS_KNOWLEDGE_ARTICLES, ANALYTICS_KNOWLEDGE_ARTICLES_SOURCES],
  [DATA_TYPE_FAMILIES.LINE_ITEMS]: ['0-8',
  // LINE_ITEM
  'EXT_LINE_ITEMS_JOINED_DEALS'],
  [DATA_TYPE_FAMILIES.LISTS]: ['0-45',
  // OBJECT_LIST
  '0-144' // LIST_MEMBER
  ],
  [DATA_TYPE_FAMILIES.MARKETING_EMAIL]: ['0-29',
  // MARKETING_EMAIL
  EMAIL],
  [DATA_TYPE_FAMILIES.MARKETING_EVENTS]: ['0-54',
  // MARKETING_EVENT
  '0-147',
  // MARKETING EVENT ATTENDANCE
  'D-MARKETING_EVENT_ACTIVITIES'],
  [DATA_TYPE_FAMILIES.PAGES]: ['0-25',
  // LANDING PAGE
  '0-38',
  // SITE_PAGE
  '0-39',
  // BLOG POST
  ANALYTICS_ALL_PAGES, ANALYTICS_BLOG_POSTS, ANALYTICS_BROWSER_DETAILS, ANALYTICS_DEVICE_TYPES, ANALYTICS_DEVICE_TYPE_DETAILS, ANALYTICS_GEOLOCATION, ANALYTICS_LANDING_PAGES, ANALYTICS_SOURCES, ANALYTICS_STANDARD_PAGES],
  [DATA_TYPE_FAMILIES.SEO]: [ANALYTICS_TOPICS],
  [DATA_TYPE_FAMILIES.SEQUENCES]: [ANALYTICS_SEQUENCE_ENROLLMENT_ACTIVITIES, '0-58',
  // SEQUENCE
  '0-68',
  // SEQUENCE_ENROLLMENT
  SEQUENCE_SENDER_SCORE],
  [DATA_TYPE_FAMILIES.SMS]: ['0-124',
  // MARKETING_SMS
  'SMS_EVENTS', 'EXT_SMS_ANALYZE_TIME_SERIES'],
  [DATA_TYPE_FAMILIES.SOCIAL]: [SOCIAL_CHANNELS, SOCIAL_POSTS],
  [DATA_TYPE_FAMILIES.TEMPLATES]: [ANALYTICS_SALES_TEMPLATES],
  [DATA_TYPE_FAMILIES.UTM_PARAMS]: [ANALYTICS_UTM_CAMPAIGNS, ANALYTICS_UTM_CONTENTS, ANALYTICS_UTM_MEDIUMS, ANALYTICS_UTM_SOURCES, ANALYTICS_UTM_TERMS]
};
export const EXPLICIT_DATA_TYPE_TO_FAMILY = Object.entries(DATA_TYPE_FAMILY_MEMBERS).reduce((dataTypeFamilyMap, [dataTypeFamily, members]) => {
  members.forEach(member => {
    if (!dataTypeFamilyMap[member]) {
      dataTypeFamilyMap[member] = [];
    }
    dataTypeFamilyMap[member].push(dataTypeFamily);
  });
  return dataTypeFamilyMap;
}, {});
export const KEYWORD_TO_DATA_TYPE_FAMILY = Object.entries(DATA_TYPE_KEYWORDS).reduce((dataTypeMap, [dataType, keywords]) => {
  keywords.forEach(keyword => {
    if (!dataTypeMap[keyword]) {
      dataTypeMap[keyword] = [];
    }
    dataTypeMap[keyword].push(dataType);
  });
  return dataTypeMap;
}, {});